import { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
const _preserve = React.version;

import { BreadcrumbGroup, Button, FormField, Header, Modal, SegmentedControl, Select, SpaceBetween } from '@cloudscape-design/components';
import { Calendar } from '@fullcalendar/react';
import listPlugin from '@fullcalendar/react/list';
import timeGridPlugin from '@fullcalendar/react/timegrid';

import '@fullcalendar/react/skeleton.css';
import themePlugin from '@fullcalendar/react/themes/classic';
import '@fullcalendar/react/themes/classic/palette.css';
import '@fullcalendar/react/themes/classic/theme.css';
import '../../../../../../src/components/css/FullCalendar.css';

import { mdiArrowDown, mdiArrowLeft, mdiArrowRight, mdiCircle } from '@mdi/js';
import Icon from '@mdi/react';
import { format, parse } from 'date-fns';
import React from 'react';
import DPModal from '../../../../../components/DPModal';
import Favorites from '../../../../../components/extras/Favorites';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { buildBreadcrumbItems, getCookie, getUrlVersion, setLoading, setParameters } from '../../../../commons/functions';
import { CustomAppLayout } from '../../../layout';
// TEMPORARILY REMOVE MONARCH


export const MembersEtcCalendarPage = () => {
    const { menu, parameters, idUser, data } = useGlobalState();
    const [events, setEvents] = useState<any[]>([]);
    const [event, setEvent] = useState<any>();
    const [index, setIndex] = useState(0);
    const [calendarType, setCalendarType] = useState("timeGridWeek");
    const calendarRef = useRef(null);
    const [categories, setCategories] = useState<any>([]);
    const [idCategory, setIdCategory] = useState(0);

    const handleDateClick = (arg: any) => {
        console.log('Clicked date:', arg.dateStr);
    };
    const formattedDate = parameters.date
        ? format(parse(parameters.date, "dd-MM-yyyy", new Date()), "yyyy-MM-dd")
        : null;

    useEffect(() => {
        if (formattedDate && calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.gotoDate(formattedDate);
        }
    }, [formattedDate]);


    const handleRefresh = async () => {
        if (parameters && parameters.date && parameters.date !== "") {
            try {
                setEvents([]);
                setLoading(true);
                const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        'x-routing': '/private/global/calendar/list',
                        'JWT': getCookie("JWT"),

                    },
                    body: JSON.stringify({
                        //date: parameters.date,
                        month: 10,
                        year: 2026
                    })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error: ${response.status}`);
                }

                const data = await response.json();
                if (data && data.events) {
                    setEvents(data.events.map((e: any) => ({
                        idEvent: e.idEvent,
                        start: e.fcDateStart,
                        end: e.fcDateEnd,
                        title: e.title,
                        color: e.color,
                        event: {
                            ...e,
                            startTime: format(parse(e.dateStart, "dd-MM-yyyy HH:mm", new Date()), "HH:mm"),
                            startDate: format(parse(e.dateStart, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy"),
                            endTime: format(parse(e.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "HH:mm"),
                            endDate: format(parse(e.dateEnd, "dd-MM-yyyy HH:mm", new Date()), "dd-MM-yyyy")
                        }
                    })));
                }
                if (data && data.categories) {
                    setCategories([
                        { label: 'Todos', value: 0 },
                        ...data.categories.map((category: any) => ({
                            label: category.category,
                            value: category.idCategory,
                        }))
                    ]);
                }

            } catch (error) {
                console.error('Error fetching users:', error);
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        handleRefresh();
    }, [parameters.date]);



    useEffect(() => {
        if (calendarRef.current) {
            const calendarApi = calendarRef.current.getApi();
            calendarApi.changeView(calendarType);
        }
    }, [calendarType]);
    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            content={
                <SpaceBetween size="s">

                    <Header variant="h1" actions={<Favorites />}>Template</Header>
                    <SpaceBetween size="s" direction="horizontal">
                        <FormField label="Fecha">

                            <DPModal today date={parameters.date} clear={false} tomorrow onConfirm={(date) => {
                                if (date !== "") {
                                    const updatedParameters = {
                                        ...parameters, // clone existing keys
                                        date: (date) // add or update
                                    };
                                    setParameters(updatedParameters);
                                }
                            }} />
                        </FormField>
                        <FormField label={'\u00A0'}>
                            <Button style={{ root: btnIconForm }}><Icon path={mdiArrowLeft} size={1} /></Button>
                        </FormField>
                        <FormField label="Vista">
                            <SegmentedControl
                                selectedId={calendarType}
                                onChange={(value) => setCalendarType(value.detail.selectedId)}
                                options={[
                                    //{ text: 'Día', id: 'timeGridDay' },
                                    { text: 'Semana', id: 'timeGridWeek' },
                                    { text: 'Mes', id: 'dayGridMonth' },
                                    { text: 'Lista', id: 'listMonth' },
                                ]}
                            />
                        </FormField>
                        <FormField label={'\u00A0'}>
                            <SpaceBetween size="xxxs" direction="horizontal">
                                <Button style={{ root: btnIconForm }}><Icon path={mdiArrowDown} size={1} /></Button>
                                <Button style={{ root: btnIconForm }}><Icon path={mdiArrowRight} size={1} /></Button>
                            </SpaceBetween>
                        </FormField>
                        <FormField label="Tipo">

                            <Select
                                placeholder='Seleccione'
                                options={categories || []} selectedOption={categories?.find((c: any) => Number(c.value) === Number(idCategory))} onChange={(e) => setIdCategory(Number(e.detail.selectedOption?.value))} />
                        </FormField>
                        {/*<Button onClick={handleButtonClick}>Refresh Equipments</Button>*/}
                    </SpaceBetween>

                    <Calendar
                        allDaySlot={false}
                        timeZone="utc"

                        plugins={[
                            themePlugin,
                            listPlugin,
                            timeGridPlugin,
                        ]}
                        ref={calendarRef}
                        events={events}
                        initialDate={formattedDate}
                        firstDay={1}
                        slotMinTime="08:00:00"
                        slotMaxTime="22:00:00"
                        //eventContent={(eventInfo) => renderEventContent(eventInfo, parameters.theme)}
                        headerToolbar={false}
                        initialView="timeGridWeek"
                        colorScheme={parameters.theme === "dark" ? "dark" : "light"}
                        dateClick={(info) => console.log(info)}
                        locale={"es"}
                        height="auto"
                        eventClick={(info) => {
                            setEvent(info.event.extendedProps.event);
                        }}
                    />
                    {!!event && (
                        <Modal size="medium" visible={!!event} onDismiss={() => setEvent(undefined)}
                            header={event?.title}
                        >
                            <FormField label={<><Icon path={mdiCircle} size={1} color={event.color} /> - {event.category}</>}>
                                {event.description}
                            </FormField>

                            {event.startDate === event.endDate && (
                                <SpaceBetween direction="horizontal" size="s">
                                    <FormField label="Fecha">
                                        {event.startDate}
                                    </FormField>
                                    <FormField label="Desde">
                                        {event.startTime}
                                    </FormField>
                                    <FormField label="Hasta">
                                        {event.endTime}
                                    </FormField>
                                </SpaceBetween>

                            )}
                            {event.startDate !== event.endDate && (
                                <SpaceBetween direction="horizontal" size="s">
                                    <FormField label="Desde">
                                        {event.startDate}
                                    </FormField>
                                    <FormField label="Hora">
                                        {event.startTime}
                                    </FormField>
                                    <FormField label="Hasta">
                                        {event.endDate}
                                    </FormField>
                                    <FormField label="Hora">
                                        {event.endTime}
                                    </FormField>
                                </SpaceBetween>
                            )}


                        </Modal>
                    )
                    }
                </SpaceBetween >
            }
        />
    )
};